module.exports = __webpack_public_path__ + "img/products2.920764ea.png";